/**
 *
 * QuestionMatrix
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Markdown from 'marked-react';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import QuestionMatrixRow from './QuestionMatrixRow';

const useStyles = makeStyles({
  matrix: {
    width: '100%',
    fontSize: 14,
    marginTop: 10,
    '& > thead > tr': {
      display: 'flex',
    },
    '& > thead > tr > th:first-child': {
      flex: '2',
      justifyContent: 'flex-start',
    },
    '& > thead > tr > th': {
      flex: '1',
      paddingTop: 8,
      paddingBottom: 8,
    },
    '& > tbody > tr': {
      display: 'flex',
    },
    '& > tbody > tr:nth-child(even)': {
      backgroundColor: '#F8F9F9',
    },
    '& > tbody > tr > td:first-child': {
      flex: '2',
      justifyContent: 'flex-start',
      position: 'relative',
      paddingLeft: 8,
    },
    '& > tbody > tr > td:first-child > div': {
      position: 'relative',
    },
    '& > tbody > tr > td': {
      flex: '1',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: 8,
      paddingBottom: 8,
    },
  },
});

function QuestionMatrix({
  name,
  columns = [],
  rows,
  answers,
  error,
  onMatrixChange,
}) {
  const classes = useStyles();
  const isMobileOrLess = useMediaQuery('(max-width:600px)');

  if (columns.length < 4) {
    return (
      <table className={classes.matrix}>
        <thead>
          <tr>
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <th />
            {columns.map(col => (
              <th key={col.text}>
                <Markdown isInline>{col.text}</Markdown>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(row => (
            <QuestionMatrixRow
              row={row}
              onChange={e => onMatrixChange(name, row.value, e.target.value)}
              columns={columns}
              key={row.text}
              answers={answers}
              error={error}
            />
          ))}
        </tbody>
      </table>
    );
  }

  return isMobileOrLess ? (
    rows.map(row => (
      <QuestionMatrixRow
        row={row}
        onChange={e => onMatrixChange(name, row.value, e.target.value)}
        columns={columns}
        key={row.text}
        isMobile
        answers={answers}
        error={error}
      />
    ))
  ) : (
    <table className={classes.matrix}>
      <thead>
        <tr>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <th />
          {columns.map(col => (
            <th key={col.text}>
              <Markdown isInline>{col.text}</Markdown>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map(row => (
          <QuestionMatrixRow
            row={row}
            onChange={e => onMatrixChange(name, row.value, e.target.value)}
            columns={columns}
            key={row.text}
            answers={answers}
            error={error}
          />
        ))}
      </tbody>
    </table>
  );
}

QuestionMatrix.propTypes = {
  name: PropTypes.string,
  columns: PropTypes.array,
  rows: PropTypes.array,
  error: PropTypes.array,
  answers: PropTypes.any,
  onMatrixChange: PropTypes.func,
};

export default QuestionMatrix;
